export default {
  'en-US': {

  },
  'es-ES': {
    
  }
};